<template lang="pug">
  v-row
    v-col.py-0(cols="12" sm="6")
      BaseTextField(v-model="form.title", :label="translations.label.banner.title" @input="emitValues")
    v-col.py-0(cols="12" sm="6")
      BaseTextField(v-model="form.description", :label="translations.label.banner.description" @input="emitValues")
    v-col.py-0(cols="12" sm="6")
      BaseTextField(rules="host" v-model="form.imageDesktop", :label="translations.label.banner.imageDesktop" @input="emitValues")
    v-col.py-0(cols="12" sm="6")
      BaseTextField(rules="host" v-model="form.imageMobile", :label="translations.label.banner.imageMobile" @input="emitValues")
    v-col.py-0(cols="12" sm="6")
      BaseTextField(rules="host" v-model="form.url", :label="translations.label.banner.url" @input="emitValues")
</template>

<script>

  export default {
    name: "LobbyBanner",
    props: {
      clearForm: {
        type: Boolean,
        default: false
      },
      translations: {
        type: Object,
        default: function(){
          return {}
        }
      },
      banner: {
        type: Object,
        default: function(){
          return {}
        }
      },
    },
    data:() =>({
      form:{
        title: '',
        description: '',
        imageDesktop: '',
        imageMobile: '',
        url: '',
      },
    }),
    watch: {
      clearForm: function(val){
        if (val){
          if(this.banner != undefined){
            this.setFields(this.banner);
          } else {
            this.clearFields();
          }
        }
      },
      banner: function(val){
        this.setFields(val);
      },
    },
    created(){
      this.setFields(this.banner);
    },
    methods:{
      emitValues(){
        this.$emit('input', this.form);
      },
      clearFields(){
        this.form.title = '';
        this.form.description = '';
        this.form.imageDesktop = '';
        this.form.imageMobile = '';
        this.form.url = '';
      },
      setFields(val){
        this.form.title = val.title;
        this.form.description = val.description;
        this.form.imageDesktop = val.imageDesktop;
        this.form.imageMobile = val.imageMobile;
        this.form.url = val.url;
      },
    },
  }
</script>

<style lang="sass">
</style>